module.exports = __webpack_public_path__ + "Lato-Black.ttf?1233fdf19c04333c7f58af4eb8698452";